import Guid from '@/app/utils/guid'
import PaginationRequest from '@/common/pagination/entities/pagination-request'

export default class CandidatesFilter {
  public search = ''
  public evaluationId = Guid.empty()
  public paging = new PaginationRequest()
}
